import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../../src/assets/HeaderPictures/headerImg1.png';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

// PDFs
import CDL_Driver_PDF from '../documents/CDL Driver.pdf';
import Regular_Applicant_PDF from '../documents/Regular Applicant.pdf';

const Header = () => {
  const location = useLocation();
  const [showApplyDropdown, setShowApplyDropdown] = useState(false);

  return (
    <Navbar expand="lg" className="custom-navbar py-3" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={logo} height="50" alt="Infiniti Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto align-items-center">
            <Nav.Link as={Link} to="/" className={`nav-link-custom ${location.pathname === '/' ? 'active' : ''}`}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about-us" className={`nav-link-custom ${location.pathname === '/about-us' ? 'active' : ''}`}>About</Nav.Link>
            <Nav.Link as={Link} to="/find-jobs" className={`nav-link-custom ${location.pathname === '/find-jobs' ? 'active' : ''}`}>Find Jobs</Nav.Link>

            {/* Custom dropdown for Apply Online */}
            <div 
              className="nav-item-custom"
              onMouseEnter={() => setShowApplyDropdown(true)}
              onMouseLeave={() => setShowApplyDropdown(false)}
            >
              <span className={`nav-link-custom ${showApplyDropdown ? 'active' : ''}`} style={{ cursor: 'pointer' }}>
                Apply Online
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="12" 
                        height="12" 
                        fill="currentColor" 
                        className={`ms-1 transition-transform ${showApplyDropdown ? 'rotate-180' : ''}`} 
                        viewBox="0 0 16 16"
                        style={{ transition: '0.3s' }}
                    >
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                </span>
              
              <div className={`custom-dropdown ${showApplyDropdown ? 'show' : ''}`}>
                <a 
                  href={CDL_Driver_PDF} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="custom-dropdown-item"
                >
                  CDL Driver Application PDF
                </a>
                <a 
                  href={Regular_Applicant_PDF} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="custom-dropdown-item"
                >
                  Standard Application PDF
                </a>
              </div>
            </div>

            <Nav.Link as={Link} to="/locations" className={`nav-link-custom ${location.pathname === '/locations' ? 'active' : ''}`}>Locations</Nav.Link>
            <Nav.Link as={Link} to="/employers" className={`nav-link-custom ${location.pathname === '/employers' ? 'active' : ''}`}>Employers</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className={`nav-link-custom ${location.pathname === '/contact-us' ? 'active' : ''}`}>Contact</Nav.Link>
            {/* <Nav.Link as={Link} to="/join" className="nav-link-custom">Join Us</Nav.Link> */}
          </Nav>

          {/* <Nav className="align-items-center">

            <Link to="/signin" className="signin-btn ms-lg-3">Sign in</Link>
            
            <Nav.Link href="#search" className="ms-lg-3 text-white">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
              </svg>
            </Nav.Link>
          </Nav> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;